module.exports = __webpack_public_path__ + "img/count-symbol-three.202d2a8a.png";